// A trilha de etapas da licitação — as seis colunas do quadro como uma faixa de
// setas, a atual em destaque com "há N dias". Clicar numa etapa move (quem
// decide se pode é o servidor; a tela só mostra a frase dele).
//
// Mesma técnica da TrilhaEtapas do negócio privado, mas com as etapas do
// processo público (etapas.ts) e sem o fluxo de "ganhar abre a venda": aqui
// Contrato assinado, Perdido e Não participamos ficam nos botões do cabeçalho,
// porque pedem motivo ou valor antes de gravar.
import { Tooltip } from 'antd';
import { ETAPAS, etapaDe, ehTerminal, normalizar } from './etapas';

const CSS = `
.tl-trilha { display: flex; min-width: 0; overflow-x: auto; }
.tl-passo { position: relative; flex: 1 1 0; min-width: 0; border: 0; font: inherit; cursor: pointer; text-align: center;
  padding: 7px 18px 7px 24px; margin-left: -8px; background: #EEF1F8; color: #5A6378;
  clip-path: polygon(0 0, calc(100% - 12px) 0, 100% 50%, calc(100% - 12px) 100%, 0 100%, 12px 50%);
  transition: background .12s; }
.tl-passo:first-child { margin-left: 0; padding-left: 14px; border-radius: 6px 0 0 6px;
  clip-path: polygon(0 0, calc(100% - 12px) 0, 100% 50%, calc(100% - 12px) 100%, 0 100%); }
.tl-passo:last-child { border-radius: 0 6px 6px 0;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%, 12px 50%); }
.tl-passo:hover:not(:disabled) { background: #E1E7F5; }
.tl-passo:focus-visible { outline: 2px solid #0930D0; outline-offset: -2px; }
.tl-passo:disabled { cursor: default; }
.tl-passo.tl-feito { background: #DCE5FB; color: #020D7F; }
.tl-passo.tl-atual { background: #0930D0; color: #fff; }
.tl-passo.tl-morto { background: #F1F2F5; color: #9AA0B4; }
.tl-passo.tl-ganho { background: #0a7f4a; color: #fff; }
.tl-nome { font-size: 12px; font-weight: 600; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; display: block; }
.tl-tempo { font-size: 10.5px; opacity: .85; display: block; white-space: nowrap; }
.tl-compacta .tl-passo { padding: 5px 8px 5px 15px; margin-left: -7px; }
.tl-compacta .tl-passo:first-child { padding-left: 8px; margin-left: 0; }
.tl-compacta .tl-nome { font-size: 10.5px; }
@media (max-width: 768px) {
  .tl-passo { flex: 1 0 auto; }
  .tl-nome { overflow: visible; }
}
`;

export function TrilhaLicitacao({ status, diasNaEtapa, onMover, compacta = false, podeOperar = true }: {
  status: string;
  diasNaEtapa: number | null;
  onMover: (para: string) => void;
  compacta?: boolean;
  podeOperar?: boolean;
}) {
  const atual = normalizar(status);
  const idx = ETAPAS.findIndex(e => e.codigo === atual);
  const terminal = ehTerminal(atual);
  const ganho = atual === 'ganho';
  const tempo = diasNaEtapa == null ? ''
    : diasNaEtapa === 0 ? 'desde hoje' : diasNaEtapa === 1 ? 'há 1 dia' : `há ${diasNaEtapa} dias`;

  return (
    <>
      <style>{CSS}</style>
      <div className={'tl-trilha' + (compacta ? ' tl-compacta' : '')} role="group" aria-label="Etapas da licitação">
        {ETAPAS.map((e, i) => {
          const ehAtual = !terminal && i === idx;
          const feito = (!terminal && idx >= 0 && i < idx) || ganho;
          const classe = 'tl-passo'
            + (ganho ? ' tl-ganho' : terminal ? ' tl-morto' : ehAtual ? ' tl-atual' : feito ? ' tl-feito' : '');
          const dica = ehAtual ? `${e.rotulo} — etapa atual${tempo ? ', ' + tempo : ''}`
            : terminal ? `${etapaDe(atual)?.rotulo || atual}. Para reabrir, use os botões.`
            : `Mover para ${e.rotulo}`;
          return (
            <Tooltip key={e.codigo} title={dica}>
              <button type="button" className={classe} aria-current={ehAtual ? 'step' : undefined}
                disabled={ehAtual || terminal || !podeOperar}
                onClick={() => onMover(e.codigo)}>
                <span className="tl-nome">{compacta ? e.curto : e.rotulo}</span>
                {ehAtual && tempo && !compacta && <span className="tl-tempo">{tempo}</span>}
              </button>
            </Tooltip>
          );
        })}
      </div>
    </>
  );
}
